(function () {
  'use strict';

  if (window.SwanHomeStory) {
    window.SwanHomeStory.init(document);
    return;
  }

  document.documentElement.classList.add('swan-home-js');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var formatter;

  try {
    formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { maximumFractionDigits: 0 });
  } catch (error) {
    formatter = { format: function (value) { return String(Math.round(value)); } };
  }

  function paintCount(element, value) {
    element.textContent = (element.getAttribute('data-prefix') || '') + formatter.format(Math.round(value)) + (element.getAttribute('data-suffix') || '');
  }

  function count(element) {
    if (element.dataset.swanCounted === 'true') return;
    element.dataset.swanCounted = 'true';

    var target = Number(element.getAttribute('data-value')) || 0;
    var duration = Number(element.getAttribute('data-duration')) || 1350;

    if (reduced || target <= 0) {
      paintCount(element, target);
      return;
    }

    var started = null;
    var from = 0;

    function frame(timestamp) {
      if (started === null) started = timestamp;
      var progress = Math.min((timestamp - started) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 4);
      paintCount(element, from + ((target - from) * eased));
      if (progress < 1) window.requestAnimationFrame(frame);
      else paintCount(element, target);
    }

    window.requestAnimationFrame(frame);
  }

  function reveal(element) {
    if (element.dataset.swanRevealed === 'true') return;
    element.dataset.swanRevealed = 'true';
    element.classList.add('is-visible');
    element.querySelectorAll('[data-swan-count]').forEach(count);
  }

  function initReveal(root) {
    var items = root.querySelectorAll ? root.querySelectorAll('[data-swan-home-animate]') : [];

    if (!('IntersectionObserver' in window) || reduced) {
      items.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(function (entries, currentObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .13 });

    items.forEach(function (item) {
      if (item.dataset.swanRevealObserved === 'true') return;
      item.dataset.swanRevealObserved = 'true';
      observer.observe(item);
    });
  }

  function loadMap(frame) {
    if (frame.dataset.swanMapLoaded === 'true') return;
    var source = frame.getAttribute('data-src');
    if (!source) return;
    frame.src = source;
    frame.dataset.swanMapLoaded = 'true';
  }

  function initMaps(root) {
    var frames = root.querySelectorAll ? root.querySelectorAll('[data-swan-map-frame]') : [];

    if (!('IntersectionObserver' in window)) {
      frames.forEach(loadMap);
      return;
    }

    var observer = new IntersectionObserver(function (entries, currentObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        loadMap(entry.target);
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '500px 0px', threshold: .01 });

    frames.forEach(function (frame) {
      if (frame.dataset.swanMapObserved === 'true') return;
      frame.dataset.swanMapObserved = 'true';
      observer.observe(frame);
    });
  }

  function initMilestones(root) {
    var carousels = root.querySelectorAll ? root.querySelectorAll('[data-swan-milestones-carousel]') : [];

    carousels.forEach(function (section) {
      if (section.dataset.swanMilestonesInitialized === 'true') return;

      var viewport = section.querySelector('[data-swan-milestone-viewport]');
      var track = section.querySelector('.swan-milestones__track');
      var previous = section.querySelector('[data-swan-milestone-prev]');
      var next = section.querySelector('[data-swan-milestone-next]');
      var progress = section.querySelector('[data-swan-milestone-progress]');
      var firstCard = section.querySelector('.swan-milestone');

      if (!viewport || !track || !firstCard) return;
      section.dataset.swanMilestonesInitialized = 'true';
      var scheduled = false;

      function maxScroll() {
        return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      }

      function cardStep() {
        var cardWidth = firstCard.getBoundingClientRect().width;
        var styles = window.getComputedStyle(track);
        var gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return cardWidth + gap;
      }

      function update() {
        scheduled = false;
        var maximum = maxScroll();
        var current = Math.max(0, viewport.scrollLeft);
        var viewedRatio = viewport.scrollWidth > 0 ? Math.min(1, (current + viewport.clientWidth) / viewport.scrollWidth) : 1;

        if (progress) progress.style.transform = 'scaleX(' + Math.max(.12, viewedRatio) + ')';
        if (previous) previous.disabled = current <= 3;
        if (next) next.disabled = current >= maximum - 3;
      }

      function scheduleUpdate() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(update);
      }

      function move(direction) {
        viewport.scrollBy({ left: cardStep() * direction, behavior: reduced ? 'auto' : 'smooth' });
      }

      previous && previous.addEventListener('click', function () { move(-1); });
      next && next.addEventListener('click', function () { move(1); });
      viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      });

      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(scheduleUpdate);
        resizeObserver.observe(viewport);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', scheduleUpdate, { passive: true });
      }

      update();
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initMaps(root);
    initMilestones(root);
  }

  window.SwanHomeStory = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
